import axios from 'axios';

import { StockProduct } from '@/models/StockProduct';

export const fetchStock = async () => {
  const response = await axios.get<StockProduct[]>('/stock');

  return response.data;
};
